import { TreeViewBaseItem } from '@mui/x-tree-view/models';

export function parseXmlToTree(xmlString: string): {
  tree: TreeViewBaseItem[],
  expandedIds: string[]
} {
  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, 'text/xml');
  const rootNode = xml.querySelector('Tree > Node');
  const expandedIds: string[] = [];

  const parseNode = (node: Element, parentPath = ''): TreeViewBaseItem => {
    const text = node.getAttribute('Text') || '';
    const currentPath = parentPath ? `${parentPath}>${text}` : text;

    const childrenElements = Array.from(node.children) as Element[];
    const children: TreeViewBaseItem[] = childrenElements.map(child =>
      parseNode(child, currentPath)
    );

    // Push the unique hierarchical ID
    expandedIds.push(currentPath);

    return {
      id: currentPath,
      label: text,
      children: children.length > 0 ? children : undefined,
    };
  };

  if (!rootNode) return { tree: [], expandedIds: [] };

  const tree = [parseNode(rootNode)];
  return { tree, expandedIds };
}


export const getExpandedIdsFromWfNodes = (wfNodesString, rootLabel) => {
    if (!wfNodesString || !rootLabel) return [];
  
    return wfNodesString
      .split(',')
      .filter(Boolean)
      .map(path => `${rootLabel}>${path}`);
  };
  